export default {
  dsn: 'https://fb3874ef74e347e09ff6685c0d539380@o452506.ingest.sentry.io/5553284',
  logErrors: true,
  environment: window.JS_ENVIRONMENT ? window.JS_ENVIRONMENT : 'unknown',
};